<template v-loading="loading">
  <el-form :model="post" :rules="rules" ref="formulaire" :element-loading-text="$t('posts.bienVendu.formDialogCreateTitle')">
    <ubi-page-container wide-main-content>
      <FormBienVendu :post="post" :is-processing="isProcessing" @handleActionBtnBV="handleActionBtnBV"></FormBienVendu>
    </ubi-page-container>
  </el-form>
</template>

<script>
import UbiPageContainer from '@/components/PageContainer.vue'
import FormBienVendu from '@/pages/posts/BienVendu/Components/FormBienVendu.vue'
import { mapGetters } from 'vuex'
import { createPost, patchPost } from '@/services/posts'
import { $t } from '@/i18n'

export default {
  name: 'BienVendu',
  components: {
    UbiPageContainer,
    FormBienVendu
  },
  inject: ['browserContext'],
  data () {
    return {
      post: null,
      action: null,
      fromNewPost: false,
      rules: {
        titre: [{ required: true, message: this.$t('validator.titleRequired'), trigger: 'blur' }],
        reference: [{ required: true, message: this.$t('validator.referenceRequired'), trigger: 'blur' }],
        code_postal: [{ required: true, message: this.$t('validator.postalCodeRequired'), trigger: 'blur' }],
        ville: [{ required: true, message: this.$t('validator.cityToShowRequired'), trigger: 'blur' }],
        surface_habitable: [{ required: true, message: this.$t('validator.isRequired'), trigger: 'blur' }],
        typeOffre: [{ required: true, message: this.$t('validator.isRequired'), trigger: 'blur' }],
        typeObjet: [{ required: true, message: this.$t('validator.isRequired'), trigger: 'blur' }],
        texte: [{ required: true, message: this.$t('validator.isRequired'), trigger: 'blur' }],
        nb_pieces_logement: [{ required: true, message: this.$t('validator.isRequired'), trigger: 'blur' }],
        dpe_valeur_conso: [{ required: true, message: this.$t('validator.isRequired'), trigger: 'blur' }],
        dpe_etiquette_conso: [{ required: true, message: this.$t('validator.isRequired'), trigger: 'blur' }],
        prix: [{ required: true, message: this.$t('validator.isRequired'), trigger: 'blur' }],
        email_a_afficher: [{ required: true, message: this.$t('validator.isRequired'), trigger: 'blur' }],
        telephone_a_afficher: [{ required: true, message: this.$t('validator.isRequired'), trigger: 'blur' }],
        contact_a_afficher: [{ required: true, message: this.$t('validator.isRequired'), trigger: 'blur' }]
      },
      loading: false,
      isProcessing: false
    }
  },
  methods: {
    handleActionBtnBV (args) {
      console.log('args', args)
      // Protection contre les clics multiples
      if (this.isProcessing) {
        console.log('Action déjà en cours, ignorer le clic')
        return
      }
      const { action, post, typeForm } = args
      if (post.etat && post.etat !== 'V') {
        post.STATUS = 'V'
      }
      if (typeForm === 'new') {
        post.STATUS = 'V'
        this.$refs.formulaire.validate((valid) => {
          if (valid) {
            this.$confirm(
              $t('posts.bienVendu.dialogConfirmBVCreationTitle'),
              {
                confirmButtonText: $t('general.calendar.acceptedPost'),
                cancelButtonText: $t('general.calendar.refusedPost'),
                type: 'warning'
              }
            ).then(() => {
              this.loading = true
              this.isProcessing = true
              createPost(post, this.sitimmoLogin, 'SAISIE_IMMO')
                .then((response) => {
                  console.log('response', response)

                  // Vérification du type de réponse d'abord
                  if (response && response.type === 'success' && response.ad && response.ad.id) {
                    this.post.id = response.ad.id
                    this.post.typeBienLibelle = response.ad.typeBienLibelle
                    this.post.typeOffreLibelle = response.ad.typeOffreLibelle
                    console.log('action', action)
                    console.log('id', response.ad.id)

                    this.$message({
                      type: 'success',
                      message: response.message || $t('posts.bienVendu.creationSuccess')
                    })

                    this.redirectAfterAction(action, response.ad.id)
                  } else if (response && response.type === 'error') {
                    console.error('Erreur retournée par le service:', response.message)
                    this.$message({
                      message: response.message || this.$t('error.found'),
                      type: 'error',
                      duration: 5000
                    })
                  } else {
                    console.error('Structure de réponse inattendue:', response)
                    this.$message({
                      message: this.$t('error.found'),
                      type: 'error',
                      duration: 5000
                    })
                  }
                }).catch((error) => {
                  console.error('Erreur lors de la création du post:', error)
                  this.$message({
                    message: this.$t('error.found'),
                    type: 'error',
                    duration: 5000
                  })
                }).finally(() => {
                  this.loading = false
                  this.isProcessing = false
                })
            }).catch(() => {
              // L'utilisateur a annulé la confirmation
              this.loading = false
            })
          } else {
            console.log('Formulaire invalide')
            this.loading = false
          }
        })
      }
      if (typeForm === 'edit') {
        this.$confirm(
          $t('posts.bienVendu.dialogConfirmBVChangeTitle'),
          {
            confirmButtonText: $t('general.calendar.acceptedPost'),
            cancelButtonText: $t('general.calendar.refusedPost'),
            type: 'warning'
          }
        ).then(() => {
          this.loading = true
          this.isProcessing = true
          post.STATUS = 'V'
          patchPost(post, this.sitimmoUser.login, 'SAISIE_IMMO')
            .then((response) => {
              console.log('response edit', response)

              this.$message({
                type: 'success',
                message: $t('posts.bienVendu.modificationSuccess')
              })

              this.redirectAfterAction(action, post.id)
            }).catch((error) => {
              console.error('Erreur lors de la modification du post:', error)
              this.$message({
                message: this.$t('error.found'),
                type: 'error',
                duration: 5000
              })
            }).finally(() => {
              this.loading = false
              this.isProcessing = false
            })
        }).catch(() => {
          // L'utilisateur a annulé la confirmation
          this.loading = false
        })
      }
    },
    redirectAfterAction (action, id) {
      console.log('redirectAfterAction - action:', action)
      console.log('redirectAfterAction - id:', id)

      if (!id) {
        console.error('ID manquant pour la redirection')
        this.$router.push({ name: 'posts' })
        return
      }

      switch (action) {
        case 'saveAndManagePosts':
          this.$router.push({ path: `/posts/manage-posts/${id}` })
          break
        case 'saveAndManageDiffusion':
          this.$router.push({ name: 'portals-selection-post', params: { post: id } })
          break
        default:
          this.$router.push({ name: 'posts' })
      }
    }
  },
  computed: {
    ...mapGetters(['isSubUser', 'isImmo', 'isVo', 'isPromoteur', 'isCmi']),
    user () {
      return this.$store.getters.getUser
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    universe () {
      return this.sitimmoUser.univers
    },
    job () {
      return this.sitimmoUser.metier
    },
    sitimmoLogin () {
      return this.sitimmoUser.login
    },
    username () {
      return this.user.username
    },
    typeOffre () {
      return this.post.typeOffre
    },
    typeObjet () {
      return this.post.typeObjet
    },
    isPromoteur () {
      return this.sitimmoUser.metier === 'PROMOTEUR'
    },
    isCmiste () {
      return this.sitimmoUser.metier === 'CMI'
    },
    getPost () {
      return this.$store.getters['bienVendu/getPost']
    },
    isEditForm () {
      return this.$route.name.split('-')[0] === 'edit'
    }
  },
  mounted () {
    if (this.$route.params.id) {
      this.$store.dispatch('bienVendu/loadPost', this.$route.params.id).then(() => {
        if (this.isEditForm) {
          this.post = {
            id: this.$route.params.id,
            titre: this.getPost.titre,
            reference: this.getPost.reference,
            prix_vendu_net: (this.getPost.prix) ? this.getPost.prix : '',
            honoraires_negociation: null,
            honoraires_negociation_vendeur: null,
            surface_habitable: (this.getPost.donnees.surface_habitable) ? this.getPost.donnees.surface_habitable.valeur : '',
            texte: this.getPost.texte,
            typeObjet: this.getPost.typeObjet,
            dpe_etiquette_conso: (this.getPost.donnees.dpe_etiquette_conso) ? this.getPost.donnees.dpe_etiquette_conso.valeur : '',
            dpe_valeur_conso: (this.getPost.donnees.dpe_valeur_conso) ? this.getPost.donnees.dpe_valeur_conso.valeur : '',
            email_a_afficher: (this.getPost.donnees.email_a_afficher) ? this.getPost.donnees.email_a_afficher.valeur : '',
            numero_voie: (this.getPost.donnees.numero_voie) ? this.getPost.donnees.numero_voie.valeur : '',
            type_voie: (this.getPost.donnees.type_voie) ? this.getPost.donnees.type_voie.valeur : '',
            nom_voie: (this.getPost.donnees.nom_voie) ? this.getPost.donnees.nom_voie.valeur : '',
            code_postal: (this.getPost.donnees.code_postal) ? this.getPost.donnees.code_postal.valeur : '',
            ville: (this.getPost.donnees.ville) ? this.getPost.donnees.ville.valeur : '',
            origine_acquereur: (this.getPost.donnees.origine_acquereur) ? this.getPost.donnees.origine_acquereur.valeur : '',
            date_compromis: (this.getPost.donnees.date_compromis) ? this.getPost.donnees.date_compromis.valeur : '',
            telephone_a_afficher: (this.getPost.donnees.telephone_a_afficher) ? this.getPost.donnees.telephone_a_afficher.valeur : '',
            typeOffre: 'V'
          }
        }
      })
    }
  },
  beforeMount () {
    if (this.$route.params.linkSocialPosts === true) {
      this.fromNewPost = true
    }

    this.post = {
      id: null,
      titre: null,
      reference: null,
      prix_vendu_net: null,
      honoraires_negociation: null,
      honoraires_negociation_vendeur: null,
      surface_habitable: null,
      status: 'B',
      texte: null,
      typeObjet: null,
      dpe_etiquette_conso: null,
      dpe_valeur_conso: null,
      email_a_afficher: null,
      telephone_a_afficher: null,
      typeOffre: 'V'
    }
  }
}
</script>
